module.exports = __webpack_public_path__ + "img/Settings-02.a8f30321.svg";